import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import QuoteFlow from './components/QuoteFlow';
import AdminPortal from './components/admin/AdminPortal';
import { QuoteProvider } from './context/QuoteContext';
import GoogleTagManager from './components/GoogleTagManager';
import Header from './components/Header';

function App() {
  return (
    <BrowserRouter>
      <QuoteProvider>
        <GoogleTagManager gtmId="GTM-WRT8XHT4" />
        <div className="min-h-screen flex flex-col bg-white text-gray-900">
          <Header />
          <Routes>
            <Route path="/" element={
              <main className="flex-grow container mx-auto px-4 py-6 max-w-lg">
                <QuoteFlow />
              </main>
            } />
            <Route path="/admin/*" element={<AdminPortal />} />
          </Routes>
        </div>
      </QuoteProvider>
    </BrowserRouter>
  );
}

export default App;